import React, { ReactNode } from 'react';
import { LayoutBuilderTypeFull, ServiceVM } from '@shared/types/process';
import { BlockViewCard } from './BlockViewCard';
import { BlockViewField } from './BlockViewField';
import { BlockViewInfo } from './BlockViewInfo';
import { BlockViewTab } from './BlockViewTab';

export const BlockView = ({
    block,
    ChildrenContext,
    service,
    childrenBtnForFlowTab,
    flowTabType,
    isParent,
    isReadOnly,
    tabProps,
    classNameWrapper,
}: {
    block: LayoutBuilderTypeFull;
    ChildrenContext: ReactNode;
    service?: ServiceVM;
    childrenBtnForFlowTab?: React.ReactNode;
    flowTabType?: React.ComponentPropsWithoutRef<
        typeof BlockViewTab
    >['flowTabType'];
    isParent?: boolean;
    isReadOnly?: boolean;
    tabProps?: React.ComponentPropsWithoutRef<typeof BlockViewTab>['tabProps'];
    classNameWrapper?: string;
}) => {
    switch (block.type) {
        case 'Card':
            return (
                <BlockViewCard
                    ChildrenContext={ChildrenContext}
                    block={block}
                    childrenBtnForFlowTab={childrenBtnForFlowTab}
                    isParent={isParent}
                />
            );
        case 'Info':
            return <BlockViewInfo block={block} />;
        case 'Field':
            return (
                <BlockViewField
                    block={block}
                    isReadOnly={isReadOnly}
                    service={service}
                />
            );
        case 'Tab':
            return (
                <BlockViewTab
                    block={block}
                    buttons={service?.buttons}
                    classNameWrapper={classNameWrapper}
                    flowTabType={flowTabType}
                    isReadOnly={isReadOnly}
                    service={service}
                    tabProps={tabProps}
                    childrenBtnForFlowTab={
                        isParent ? childrenBtnForFlowTab : undefined
                    }
                />
            );
        case 'TabItem':
            return ChildrenContext;
        default:
            break;
    }
};
